import axiosClient from "../api/axiosClient";

export const getMyChatRooms = (roomType = "Personal", pageNumber = 1, pageSize = 20) =>
  axiosClient.get("/Chat/GetMyChatRooms", {
    params: { roomType, pageNumber, pageSize },
  });
